import type { CosmosRouteSpace } from '../_contract/cosmosRoute';
import type { EpisodeAuditionOwner } from '../_contract/episodeSupport';

export function resolveEpisodeAuditionOwner(handle: string, owners: readonly EpisodeAuditionOwner[]) {
    const matches = owners.filter(owner => owner.auditions.isHandle(handle));
    if (matches.length > 1) throw new Error(`Ambiguous audition ownership for '${handle}'.`);
    return matches[0];
}

export function withEpisodeAuditionRoutes(spaces: readonly CosmosRouteSpace[], owners: readonly EpisodeAuditionOwner[]): CosmosRouteSpace[] {
    return spaces.map(space => {
        const handles = owners.filter(owner => owner.spaceSlug === space.spaceSlug)
            .flatMap(owner => [...owner.auditions.episodeHandles()]);
        for (const handle of handles) {
            if (resolveEpisodeAuditionOwner(handle, owners)?.spaceSlug !== space.spaceSlug) {
                throw new Error(`Invalid audition ownership for '${handle}'.`);
            }
        }
        return { ...space, episodeHandles: [...new Set([...space.episodeHandles, ...handles])] };
    });
}
